module.exports = __webpack_public_path__ + "img/search-gray.c4d1e387.svg";